// Public wedding landing (FR-1).
// Mounts the shared InvitationArtwork and feeds it the DB-backed event
// settings via the `useEventSettings` hook. The artwork falls back to
// EVENT_DATA while the query is loading (or if it errors), so the first
// render is byte-identical to the seed — no CLS, no loading skeleton.
import { InvitationArtwork } from '../components/decor';
import { useEventSettings } from '../hooks/useEventSettings.js';

export default function Home() {
  const { data: eventSettings } = useEventSettings();
  return <InvitationArtwork eventSettings={eventSettings} />;
}
